import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { isEmpty } from '../../../common/functions';
import { InsectaServiceBase } from '../insecta.base.service';
import { IInsect, IInsectAddRequest, IInsectUpdateRequest } from '../insecta.models';

@Injectable({
  providedIn: 'root'
})
export class InsectAdminService extends InsectaServiceBase {
  public getInsect(id: string): Observable<IInsect> {
    return this.get<IInsect>(`/admin/insects/${id}`, 'v1');
  }

  public getInsects(includeInActive: boolean | null | undefined): Observable<IInsect[]> {
    if (isEmpty(includeInActive)) includeInActive = false;

    return this.get<IInsect[]>(`/admin/insects?IncludeInactive=${includeInActive}`, 'v1').pipe(
      map((results) => [...results].filter((x: IInsect) => includeInActive || x.isActive)),
      map((results) =>
        [...results].sort((a: IInsect, b: IInsect) =>
          a.isActive == b.isActive ? (a.scientificName > b.scientificName ? 1 : -1) : a.isActive < b.isActive ? 1 : -1
        )
      )
    );
  }

  public addInsect(request: IInsectAddRequest): Observable<string> {
    return this.post<string>(`/admin/insects`, 'v1', request);
  }

  public updateInsect(request: IInsectUpdateRequest): Observable<any> {
    return this.put(`/admin/insects/${request.id}`, 'v1', request);
  }
}
